module.exports = __webpack_public_path__ + "img/pocket_bag_height.dfdd16f7.png";